import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
// ui
import { Box, Flex, ModalCancelButton, ModalActionButton } from '../../ui';
//////////////////////////////////////////////////

const commonBtnStyles = { mr: 20, width: 150 };

const ButtonsBlock = ({ buttons, saveAsNew, showSaveAsNew, saveAsNewBtnType }) => (
  <Box>
    {
      G.isTrue(showSaveAsNew) &&
      <ModalActionButton {...commonBtnStyles} onClick={saveAsNew} type={R.or(saveAsNewBtnType, 'button')}>
        {G.getWindowLocale('actions:save-as-new', 'Save As New')}
      </ModalActionButton>
    }
    {
      buttons.map(({ type, action, width, btnText, disabled, handleClick }, i) => (
        <ModalActionButton
          {...commonBtnStyles}
          key={i}
          disabled={disabled}
          width={R.or(width, 'auto')}
          type={R.or(type, 'button')}
          onClick={R.or(action, handleClick)}
        >
          {btnText}
        </ModalActionButton>
      ))
    }
  </Box>
);

export const FormButtons = (props) => {
  const {
    pl,
    pr,
    style,
    zIndex,
    formId,
    btnText,
    position,
    submitting,
    saveDisabled,
    showSaveAsNew,
    justifyContent,
    hideFormSaveBtn,
    handleClickSave,
    saveAsNewBtnType,
    showCancel = true,
    handleClickCancel,
    handleClickSaveAsNew,
  } = props;

  return (
    <Flex
      left={0}
      bottom={0}
      height={60}
      width='100%'
      style={style}
      pl={R.or(pl, 70)}
      pr={R.or(pr, 20)}
      borderTop='1px solid'
      zIndex={R.or(zIndex, 12)}
      transition='all .2s linear'
      bg={G.getTheme('colors.white')}
      position={R.or(position, 'fixed')}
      justifyContent={R.or(justifyContent, 'space-between')}
      borderColor={G.getTheme('forms.actionsFooter.borderTopColor')}
    >
      {
        G.isTrue(showCancel) &&
        <ModalCancelButton {...commonBtnStyles} type='button' onClick={handleClickCancel}>
          {G.getWindowLocale('actions:cancel', 'Cancel')}
        </ModalCancelButton>
      }
      <Flex {...G.ifElse(showCancel, {}, { width: '100%', justifyContent: 'flex-end' })}>
        <ButtonsBlock
          showSaveAsNew={showSaveAsNew}
          saveAsNew={handleClickSaveAsNew}
          saveAsNewBtnType={saveAsNewBtnType}
          buttons={R.pathOr([], ['buttons'], props)}
        />
        {
          R.not(G.isTrue(hideFormSaveBtn)) &&
          <ModalActionButton
            {...commonBtnStyles}
            mr='0px'
            type='submit'
            form={formId}
            onClick={handleClickSave}
            disabled={R.or(saveDisabled, submitting)}
            cursor={G.ifElse(R.or(saveDisabled, submitting), 'not-allowed', 'pointer')}
          >
            {R.or(btnText, G.getWindowLocale('actions:save', 'Save'))}
          </ModalActionButton>
        }
      </Flex>
    </Flex>
  );
};
